import img1 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-indoen.jpg";
import img2 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-indoen1.jpg";
import img3 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-achter-schaambot-klemmen.jpg";
import img4 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-zij-aanzicht.jpg";
import img5 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-eruit-halen-manier.jpg";
import img6 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-eruit-halen.jpg";
import img7 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-lekt-bij-eruithalen.jpg";
import img8 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-lekt-door.jpg";
import img9 from "../assets/faqImg/menstruatiedisk-gevouwen-indoen-gevouwen-model.jpg";
import img10 from "../assets/img/menstruatiedisk-verschillende-disks-naast-elkaar-gevouwen.jpg";
import img11 from "../assets/faqImg/menstruatiecup-gevouwen-inbrengen.jpg";
import img12 from "../assets/faqImg/menstruatiedisk-gevouwen-indoen-gevouwen-model.jpg";
import img13 from "../assets/faqImg/menstruatiecup-baarmoedermodel.jpg";
import img14 from "../assets/faqImg/menstruatiedisk-zit-goed.jpg";
import img15 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-zij-aanzicht.jpg";
import img16 from "../assets/img/menstruatiedisk-verschillende-disks-naast-elkaar-gevouwen.jpg";
import img17 from "../assets/img/menstruatiedisk-verschillende-disks-naast-elkaar.jpg";
import img18 from "../assets/faqImg/menstruatiedisk-gebruiken-handleiding-verkeerd-indoen.jpg";

export const insertDisc = [
        {
            alt: 'menstruatiedisk gevouwen indoen',
            caption: 'menstruatiedisk gevouwen indoen',
            image: img1,
        },
        {
            alt: 'Breng hem schuin in, richt op je middenrug. Niet recht omhoog, zoals bij een tampon.',
            caption: 'Breng hem schuin in, richt op je middenrug. Niet recht omhoog, zoals bij een tampon.',
            image: img2,
        },
        {
            alt: 'Duw de disk-rand omhoog, en klem zo de disk vast achter je schaambeen.',
            caption: 'Duw de disk-rand omhoog, en klem zo de disk vast achter je schaambeen.',
            image: img3,
        },
        {
            alt: 'De disk zit goed, je kunt hem zo 12 uur dragen.',
            caption: 'De disk zit goed, je kunt hem zo 12 uur dragen.',
            image: img4,
        }
    ];

export const removeDisc = [
    {
        alt: 'menstruatiedisk',
        caption: 'Je kunt de disk met twee vingers proberen vast te pakken. Kom je er niet goed bij? Probeer wat te persen, om hem omlaag en binnen handbereik te krijgen.',
        image: img5,
    },
    {
        alt: 'menstruatiedisk',
        caption: 'Of met een vinger achter de rand proberen te haken. Hierbij heb je wel meer kans op lekken tijdens het eruit halen.',
        image: img6,
    },
    {
        alt: 'menstruatiedisk',
        caption: 'De disk zal wat op je vingers lekken. Dit kun je er er gewoon weer afspoelen.',
        image: img7,
    }
];

export const troubleWithDisc = [
    {
        alt: 'menstruatiedisk',
        caption: 'Je hebt de disk waarschijnlijk recht omhoog in gedaan, dat moet je niet doen! Mik meer richting je middenrug tijdens het inbrengen in plaats van recht omhoog.',
        image: img18,
    },
    {
        alt: 'menstruatiedisk',
        caption: 'Zit er bloed aan de onderkant van je disk? Dan zit de disk niet goed onder je baarmoedermond. Waarschijnlijk heb je hem niet schuin genoeg ingedaan.',
        image: img8,
    },
    {
        alt: 'menstruatiedisk',
        caption: 'Je moet de disk schuin in doen, meer mikken op je middenrug.',
        image: img1,
    },
];

export const troubleWithDisc2 = [
    {
        alt: 'menstruatiedisk',
        caption: 'Mik tijdens in inbrengen van de disk richting je middenrug tijdens het inbrengen in plaats van recht omhoog. Zo komt hij onder je baarmoedermond in plaats van ernaast.',
        image: img1,
    },
    {
        alt: 'menstruatiedisk',
        caption: 'Heb je de disk wel echt goed achter je schaambot geklemd? Duw hem zo ver mogelijk omhoog.',
        image: img3,
    },
];


export const foldDisc = [
    {
        alt: 'Een gevouwen disk en een ongevouwen disk.',
        caption: 'Een gevouwen disk en een ongevouwen disk.',
        image: img10,
    },
    {
        alt: 'Je vouwt een disk door de zijkanten in te drukken.',
        caption: 'Je vouwt een disk door de zijkanten in te drukken.',
        image: img9,
    },
];

export const discVsCup = [
    {
        alt: 'Een gevouwen menstruatiecup in doen',
        caption: 'Een gevouwen menstruatiecup in doen',
        image: img11,
    },
    {
        alt: 'Een gevouwen menstruatiedisk indoen',
        caption: 'Een gevouwen menstruatiedisk indoen',
        image: img12,
    },
    {
        alt: 'hoe hoog je een menstruatiecup draagt',
        caption: 'hoe hoog je een menstruatiecup draagt',
        image: img13,
    },
    {
        alt: 'hoe hoog je een menstruatiedisk draag',
        caption: 'hoe hoog je een menstruatiedisk draagt',
        image: img14,
    },
];

export const discImages = [
    {
        alt: 'menstruatiedisk',
        caption: 'menstruatiedisk waar je hem draagt',
        image: img15,
    },
    {
        alt: 'menstruatiedisk',
        caption: 'menstruatiedisk',
        image: img16,
    },

    {
        alt: 'menstruatiedisk',
        caption: 'menstruatiedisk',
        image: img17,
    },
    {
        alt: 'Een gevouwen menstruatiedisk indoen',
        caption: 'Een gevouwen menstruatiedisk indoen',
        image: img12,
    },
];